class ErrorHandler {
    constructor(error) {
        this.error = error
    }

    get send() {
        if (process.env.NODE_ENV !== 'production') {
            console.log(this.error)
        }
        throw new Error(this.error.message || 'Unknown error', { cause: this.error })
    }
}

export default ErrorHandler
